import request from '@/utils/request'

/**
 * 获取提现申请列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function listStateWithdrawalApplys(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountWithdrawalApply/listStateWithdrawalApplys',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}